import { useEffect, useState, useReducer, useRef } from 'react';
import { useQuery } from 'react-query'

export const operators = {
	numericOperators: {
		'<':"Less than",
		'<=':"Equal to or less than",
		'=':"Equal to",
		'>=':"Equal to or greater than",
		'>':"Greater than",
		'<>':"Different from",
		'REGEX':"Regular expression"
	},

	textOperators: {
		'like':"Contains",
		'=':"Equal to",
		'^':"Starts with",
		'REGEX':"Regular expression"
	},

	multipleOperators: {
		'values':"In a list"
	},

	dateOperators: {
		'<':"Before",
		'>':"After",
	},
}

export const arrayOperators = {
	dateOperators: [
		{ k:'<', v:"Before" },
		{ k:'>', v:"After" },
		{ k:'=', v:"At" },
	],

	textOperators: [
		{ k:'like', v:"Contains" },
		{ k:'=', v:"Equal to" },
		{ k:'^', v:"Starts with" },
		{ k:'REGEX', v:"Regular expression" },
	],

	simpleTextOperators: [
		{ k:'like', v:"Contains" },
		{ k:'REGEX', v:"Regular expression" },
	],

	numericOperators: [
		{ k:'<', v:"Less than" },
		{ k:'<=', v:"Equal to or less than" },
		{ k:'=', v:"Equal to" },
		{ k:'>=', v:"Equal to or greater than" },
		{ k:'>', v:"Greater than" },
		{ k:'<>', v:"Different from" },
		{ k:'REGEX', v:"Regular expression" },
	],
}

export const usePaginator = (items,nPage,options={}) => {
	options = {pages_to_display:9,...options};
	const skip_reset_page = options.skip_reset_page != undefined ? options.skip_reset_page : false;
	const reset_page_on_items_length = options.reset_page_on_items_length != undefined ? options.reset_page_on_items_length : false;
	const limit_data = options.limit;
	const entries_per_page = (nPage != undefined) ? nPage : 100;

	const [page, setPage] = useState(1);
	const [total_pages, setTotalPages] = useState(1);
	const [pages_arr, setPagesArray] = useState([]);
	const [paged,setPaged] = useState([]);
	const items_length = useRef(0);

	useEffect(() => {
		if(!items && options.total == undefined) return;

		let paginated;
		if (limit_data != undefined && limit_data != 0) {
			paginated = items.slice(0,limit_data);
		}
		else {
			paginated = items;
		}

		const num_items = options.total != undefined ? options.total:paginated.length ;
		setTotalPages(Math.ceil(num_items / entries_per_page));
		
		if (skip_reset_page || (reset_page_on_items_length && paginated.length == items_length.current)) {
			const newpage = paginated.slice((page - 1) * entries_per_page, page * entries_per_page);
			setPaged(newpage);
			return;
		}
		items_length.current = paginated.length;

		setPage(1);
		setPaged(paginated.slice(0, entries_per_page));
	}, [items,skip_reset_page,limit_data]);

	useEffect(() => {
		let pages_arr = [];

		let page_ini = Math.max(page - Math.ceil(options.pages_to_display / 2) + 1, 1);
		let page_end = Math.min(total_pages, page_ini + options.pages_to_display);
		if(page_end > options.pages_to_display && (page_end - page_ini) < options.pages_to_display) page_ini = page_end - options.pages_to_display;
		for(var i = page_ini; i < page_end + 1; i++) {
			pages_arr.push(i);
		}
		setPagesArray(pages_arr);
	}, [page, total_pages]);

	const goToPage = (new_page) => {
		const newpage = items.slice((new_page - 1) * entries_per_page, new_page * entries_per_page);
		setPaged(newpage);
		setPage(new_page);
	};

	return [paged,{total_pages,page,pages_arr},goToPage];
}


export const useFilterData = (data,initial,_filters = []) => {
	const reducer = (state,action) => {

		switch(action.type) {

			case 'SETDATA':

				if (!action.data) return state;

				return {
					...state,
					data:action.data.data,
					indexed:options.indexer == undefined ? {} :indexData(action.data.data,options.indexer),
					filtered: filterData(action.data.data,state.filters),
					total:action.data.total != undefined ? action.data.total : state.total,
					last:action.data.last
				}
			case 'APPENDDATA':
				const joined = [...state.data,...action.data.data];
				return {
					...state,
					data:joined,
					indexed: options.indexer == undefined ? {} : indexData(action.data.data,options.indexer,state.indexed),
					filtered: filterData(joined,state.filters)
				}

			case 'PREPEND_DATA':
				const prepended = [...action.data,...state.data];
				return {
					...state,
					data:prepended,
					indexed: options.indexer == undefined ? {} : indexData(action.data,options.indexer,state.indexed),
					filtered: filterData(prepended,state.filters)
				}

			case 'SEARCH':

				var filters = updateFilter(state.filters,{key:'search',value:action.value});
				var filtered = filterData(state.data,filters);
				return {
					...state,
					search:action.value,
					filters,
					filtered
				};

			case 'SETFILTER':
				var filters = updateFilter(state.filters,action.filter,action.unique);
				var filtered = filterData(state.data,filters);
				sortData(filtered,state.sort);
				return {
					...state,
					filters,
					filtered
				};

			case 'SETSORT':
				var sort = action.sort;
				let sorted = [...state.filtered];
				sortData(sorted,sort);
				return {
					...state,
					filtered:sorted,
					sort
				};

			case 'APPLYFILTERS':
				var filtered = filterData(state.data,state.filters);
				sortData(filtered,state.sort);
				return {
					...state,
					filtered:filtered
				};

			case 'APPLYBULK':
				var filtered = state.filtered.map(u=>{
					if (action.ids != undefined) {
						if (action.ids.includes(u.User.id)) return action.bulk(u);
						return u;
					}
					return action.bulk(u)
				});
				return {
					...state,
					filtered:filtered
				};
			
			case 'APPLYBULK_GENERIC':
				var filtered = state.filtered.map((u) => {
					if(action.ids != undefined && u[action.Model] != undefined) {
						if(action.ids.includes(u[action.Model].id)) return action.bulk(u);
						return u;
					}

					return action.bulk(u);
				});

				return {
					...state,
					filtered,
				};

			case 'APPLY_ACTION':
				var data = state.data.map(u=>{
					return action.match(u) ? action.action(u) : u;
				});
				var filtered_after = filterData(data,state.filters);
				sortData(filtered_after,state.sort)
				return {
					...state,
					data,
					filtered:filtered_after
				};

			case 'APPLYBULK_PARTICIPANT':
				var filtered = state.filtered.map(u=>{
					if (action.ids != undefined) {
						if (action.ids.includes(u.Participation.id)) return action.bulk(u);
						return u;
					}
					return action.bulk(u)
				});
				
				return {
					...state,
					filtered:filterData(filtered,state.filters)
				};

			case 'REMOVE_ENTRY':
				var filtered = filterData(state.data.filter(u=>u.Participation.id != action.uid),state.filters);
				sortData(filtered,state.sort);
				return {
					...state,
					data:state.data.filter(u=>u.Participation.id != action.uid),
					filtered:filtered
				};

			case 'REMOVE_USER':
				var filtered = filterData(state.data.filter(u=>u.User.id != action.uid),state.filters);
				sortData(filtered,state.sort);
				return {
					...state,
					data:state.data.filter(u=>u.User.id != action.uid),
					filtered:filtered
				};

			case 'REMOVE_CV':
				var filtered = filterData(state.data.filter(u=>u.CodeValidation.id != action.id),state.filters);
				sortData(filtered,state.sort);
				return {
					...state,
					data:state.data.filter(u=>u.CodeValidation.id != action.id),
					filtered:filtered
				};

			case 'REMOVE_GENERIC':

				var filtered = filterData(state.data.filter(u=>u[action.Model].id != action.id),state.filters);
				sortData(filtered,state.sort);
				return {
					...state,
					data:state.data.filter(u=>u[action.Model].id != action.id),
					filtered:filtered
				};

			case 'ADDFILTER':
				var filters = updateFilter(state.filters,action.filter);
				return {
					...state,
					filters,
				};

			case 'RESET_FILTERS':
				return {
					...state,
					filters:[],
					filtered:filterData(state.data,[]),
					search:''
				}

			case 'REMOVEFILTER':
				var filters = removeFilter(state.filters,action.filter);
				var filtered = filterData(state.data,filters);
				sortData(filtered,state.sort);
				return {
					...state,
					filters,
					filtered
				};

			case 'SETFILTERED':
				return {
					...state,filtered:action.filtered
				};
		
			case 'SETLIMIT':
				return {
					...state,
					limit:action.limit
				}
		}
		return state;
	}

	let options = initial || {};

	const [state,dispatch] = useReducer(reducer, {
		filters:_filters,
		indexed:{},
		search:'',
		filtered:[],
		data,
		limit:0
	});
	
	useEffect(()=>{
		if (data?.data == undefined) {
			return;
		}
		dispatch({type:'SETDATA',data});
	},[data])

	return [state, dispatch];
}

export const useFilterDataQuery = (key, fetchFunc, options) => {
	options = options || {};
	let limit = (options.limit != undefined) ? options.limit : 100;
	let pagination = (options.pagination != undefined) ? options.pagination : 1000;
	let fetch_all_disabled = (options.fetch_all_disabled != undefined) ? options.fetch_all_disabled : false;

	const { data,refetch } = useQuery(key, () => fetchFunc(false, limit), { refetchOnWindowFocus:false });

	const [state, dispatch] = useFilterData(data, options);

	const getAll = (data_already_present,callback) => {
		
		function fetchMoreData(data,callback) {
			const get = fetchFunc(data.last, pagination,data?.offset);
			let offset = data?.offset;
			get.then((data) => {
				dispatch({type:'APPENDDATA',data});
				if (offset != undefined) {
					offset += pagination;
					data.offset = offset;
				} 
				if(data.data.length == pagination || data?.hasMore) fetchMoreData(data,callback);
				else {
					if (callback) callback();
				}
			});
		}
		fetchMoreData(data_already_present,callback);
	}

	useEffect(() => {
		if(data && parseInt(data.total) > limit) {
			if(fetch_all_disabled) {
				dispatch({type:'SETDATA',data});
				return;
			}
			function fetchChunked(data) {
				const get = fetchFunc(data.last, pagination);

				get.then((data) => {
					dispatch({type:'APPENDDATA',data})
					if(data.data.length == pagination || data?.hasMore) fetchChunked(data);
				});
			}
			fetchChunked(data);
		}
		dispatch({type:'SETDATA',data})
	}, [data]);
	return [state,dispatch,getAll,refetch];
}


const numericFilter = (filter,current) => {
	if (!isNaN(current)) current = parseFloat(current);
	if (!isNaN(filter.value)) filter.value = parseFloat(filter.value);

	switch(filter.operator) {
		case "<>":
			return current != filter.value;

		case "=":
			return current == filter.value;

		case "<":
			return current < filter.value;

		case "<=":
			return current <= filter.value;

		case ">=":
			return current >= filter.value;

		case ">":
			return current > filter.value;

		case "REGEX":
			const reg = new RegExp(filter.value,'i');
			return reg.test(current);
	}
}

const normalizeString = (str) => {
	// Normalizar la cadena para separar las letras de las tildes y diacríticos
	// y luego eliminar esos diacríticos con una expresión regular.
	// También elimina espacios con `.replace(/\s+/g, '')`
	return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '').toLowerCase();
  }

const stringFilter = (filter,current) => {

	const REGEX_SPECIAL_CHARS_GLOBAL = /([-*+?.^${}(|)[\]])/g;
	const value = filter.value.replace(REGEX_SPECIAL_CHARS_GLOBAL, '\\$1');



	let reg;
	switch(filter.operator) {
		case "<>":
			return current != filter.value;
		case "=":
			return current == filter.value;
		case "REGEX":
			reg = new RegExp(value,'i');
			return reg.test(current);
		case "^":
			reg = new RegExp("^"+value,'i');
			return reg.test(current);
		case "like_all":
			reg = new RegExp(normalizeString(value),'i');
			return reg.test(normalizeString(current));
		case "like":
		default:
			reg = new RegExp(value,'i');
			return reg.test(current);
	}
}

export const parametrizeFilter = (currentFilter, params) => {
	if(params == undefined) return currentFilter;

	let filter = { ...currentFilter, filter:{ ...currentFilter.filter } };

	//Multipath OR
	const [expandedTier, nameExpanded] = expandMultipleParams(filter, params);

	if(!expandedTier) {
		let tier1 = filter.filter.tier1;
		let name = filter.filter.template;
		for(var i in params) {
			if (typeof tier1 == 'function') continue;
			tier1 = tier1.replace(`{${i}_id}`,params[i].k);
			name = name.replace(`{${i}}`,params[i].v);
		}
		filter.filter.tier1 = tier1;
		filter.key = tier1;
		filter.filter.name = name;
	} else {
		filter.filter.tier1 = expandedTier;
		filter.filter.name = nameExpanded;
	}

	if(filter.value == undefined) filter.value = 1;
	if (filter.operator == undefined && Array.isArray(filter.value)) filter.operator = '=';
	if(filter.operator == undefined) filter.operator = 'like';
	
	return filter;
}

const expandMultipleParams = (filter, params) => {
	const multiValues = [];
	for(var j in params) {
		if(!Array.isArray(params[j])) continue;
		multiValues.push(j);
	}

	if(multiValues.length == 0) return [false];

	let expandedTier = [];
	let values = [];
	let tier1 = filter.filter.tier1;
	let name = filter.filter.template;

	for (var i in params) {
		if (multiValues.includes(i)) continue;
		if (typeof tier1 != 'function') {
			tier1 = tier1.replace(`{${i}_id}`,params[i].k);
		}
		name = name.replace(`{${i}}`,params[i].v);
	}

	multiValues.forEach(param=> {
		values = [];
		if(expandedTier.length == 0) {

			params[param].forEach(value => {
				if (typeof tier1 != 'function') {
					expandedTier.push(tier1.replace(`{${param}_id}`,value.k))
				}
				else {
					expandedTier.push(tier1);
				}
				values.push(value.v);
			})
		} else {
			for(var k in expandedTier) {
				params[param].forEach(value => {
					expandedTier.push(expandedTier[k].replace(`{${param}_id}`,value.k))
					values.push(value.v);
				})
				expandedTier.splice(k,1);
			}
		}
		name = name.replace(`{${param}}`,values.join(' OR '));
	});

	return [expandedTier, name];
}

const getProp = (key, object) => {
	const path = (Array.isArray(key)) ? key : key.split('.');

	return path.reduce((acc, current, idx, src) => {
		if(current == '*') {
			const data = acc.map(item=>{
				return getProp(src.slice(idx+1),item);
			})
			src.splice(idx);
			return data;
		}
		if(acc == undefined) return undefined;
		return acc[current];
	}, object);
}

const getPropNested = (key,object) => {
	const path = Array.isArray(key)?key:key.split('.');
	const res = path.reduce((acc,current,idx,src)=>{
		if (acc == undefined) return undefined;
		if (current == '*') {
			return [acc,src[idx-1],src.splice(idx+1)];
		}
		return acc[current];
	},object)

	return (!Array.isArray(res)) ? [res] :res;
}


const updateFilter = (filters,newfilter,unique=false) => {

	let find_key = newfilter.key;
	if (newfilter.filter.dynamickey != undefined) {
		find_key = newfilter.filter.dynamickey(newfilter.options);
	}
	
	let filter = filters.find(f=>(f.key == find_key && f.operator == newfilter.operator));

	if (!filter) {
		return [...filters,{...newfilter,key:find_key}];
	}
	else {

		if (newfilter.value == "") return filters.filter(f=>f.key != find_key);
		let f = filters.map(f=>{
			if (f.key != find_key) return f;
			return {...newfilter}
		});
		return f;
	}
}

const removeFilter = (filters,filter) => {
	return filters.filter(f=>(f.key != filter.key || f.operator != filter.operator));
}

const logicFilter = (values,targets,logic,fn) => {
	switch (logic) {
		//If all targets are matched by one or more of the values
		case 'AND':
			for (var t in targets) {
				var found = false;
				for (var i in values) {
					if (fn(targets[t],values[i])) {
						found = true;
						break;
					}
				}
				if (!found) return false;
			}
			return true;

		case 'OR':
			for (var i in values) {
				for (var t in targets) {
					if (fn(targets[t],values[i])) return true;
				}
			}
			return false;
			break;

	}
}


const matchSingleValue = (type,key,operator,value,target) => {
	switch(type) {
		case 'numeric':
			return numericFilter({operator,value},target);
		case 'string':
			return stringFilter({operator,value},target);
		case 'date':
			value = operator == '=' ? value.split(' ')[0] : value;
			return numericFilter({operator,value},target);
		case 'multiple':
			return value == target;
		case 'in_array':
			return target.includes(value);
		default:
			switch(key) {
				default:
					let reg = (operator != 'regexp' && operator != "REGEX") ? (""+value).replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"): value;	
					let regular = RegExp(reg,'i');

					if (operator == '=') {
						regular = RegExp('^'+reg+"$");
					}
					return regular.test(target);
			}
			break;
	}
	return false;

}

const pruneAndFulfill = (items,filter) => {

	let values = Array.isArray(filter.value) ? filter.value : [filter.value];

	let toMatch = values.slice(0);
	
	filter.key = Array.isArray(filter.key) ? filter.key.join('.') : filter.key;

	const logic = filter.logic == undefined ? 'AND' : filter.logic;
	
	const pruned = items.filter(item=>{

		const value = getProp(filter.key,item);
		
		let matched = false;

		if (value == undefined) return matched;
		
		values.map(target => {
			const res = matchSingleValue(filter.filter.type,filter.key,filter.operator,target,value);
			if (res) {
				matched = true;

				toMatch = logic == 'AND' ? toMatch.filter(m=>m!=target) : [];
			}
		})
		return matched;
	})

	return [pruned,toMatch.length == 0];

}

const indexData = (data,indexer,previous) => {
	let indexed = previous || {};
	if(data == undefined) return indexed;
	data.forEach(u => {
		indexer(indexed,u);
	})
	return indexed;
}

const sortData = (data,order) => {
	if (!order) return;
	data.sort((a,b)=>{
		let aV = getProp(order.field,a);
		let bV = getProp(order.field,b);
		switch(order.type) {
			case 'numeric':
				aV = parseFloat(aV);
				bV = parseFloat(bV);
		}
		const res = aV < bV ? -1 : 1;

		return (order.direction == 'ASC' ? res : (-1*res));
	});
}

const filterData = (data,filters) => {

	if (data == undefined) return data;

	let matching = data.slice(0);
	var res;

	let matched = [];

	let match_key = {};
	matching = matching.filter(u=>{
			
		let user = {...u};

		let valid = true;

		filters.map(filter=>{

			if (!valid) return;

			const logic = filter.logic != undefined ? filter.logic : 'OR'
			
			if (!Array.isArray(filter.filter.tier1)) filter.filter.tier1 = [filter.filter.tier1];

			let combinedPrune = false;
			let totalfulfilled = false;
			let property = null;
			let matched = [];
			let tierMatched = false;

			filter.filter.tier1.forEach(tier1=>{
				if (tierMatched) return;
				var tomatch;
				
				if (typeof tier1 == 'function') {
					tomatch = tier1(u,filter);
				} else {
					//Get nested data if any
					var [tomatch,prop,path] = getPropNested(tier1,user);
				}
				if (tomatch == undefined) {
					valid = false;
					return;
				}
				property = prop;

				if (filter.filter.type == 'predicate') {
					if (tomatch) {
						matched = true;
						return;
					}
					valid = false;
					return;
				}

				//There is nested data?
				if (Array.isArray(tomatch) && filter.filter.type != 'in_array') {

					if(filter.filter.type == 'matchNone') {

						if (tomatch.length == 0) {
							matched = true;
							tierMatched = true;
							valid = true;
							return;
						}

						matched = false;
						tierMatched = false;
						valid = false;
						return;
					}

					if (filter.filter.type == 'matchAny') {
						if (tomatch.length > 0) {
							matched = true;
							tierMatched = true;
							valid = true;
							return;
						}
						matched = false;
						tierMatched = false;
						valid = false;
						return;
					}


					if (combinedPrune === false) combinedPrune = [];
					const [pruned,fulfilled] = pruneAndFulfill(user[prop],{
						filter:filter.filter,
						key:path,
						operator:filter.operator,
						value:filter.value,
						logic
					});

					combinedPrune = [...combinedPrune,...pruned];
					if (fulfilled) totalfulfilled = true;
					// user = {...user,[prop]:pruned};
					// if (!fulfilled) valid = false;
					return;
				}


				let values = Array.isArray(filter.value) ? filter.value : [filter.value];

				filter.tier1 = Array.isArray(filter.key) ? filter.key.join('.') : tier1;
				
				matched = false;
				
				let can_match = true;

				if (filter.filter.type == 'in_array' && filter.operator =='has_none') {
					if (tomatch.length == 0) {
						matched = true;
						valid = true;
					}
					can_match = false;
				}
				
				values.map(target => {

					if (matched) return;
					if (!can_match) return;
					const res = matchSingleValue(filter.filter.type,tier1,filter.operator,target,tomatch);

					if (logic == 'AND' && !res) {
						can_match = false;
					}

					if (logic == 'OR' && res) {
						matched = true;
						tierMatched = true;
						valid = true;
					}
				})

				if (logic == 'AND' && can_match) {
					matched = true;
					valid = true;
				}
				
				if (!matched) {
					valid = false;
				}

			})

			if (combinedPrune !== false) {
				if (combinedPrune.length > 0) {


					user = {...user,[property]:combinedPrune};
					if (!totalfulfilled) valid = false;
					else {
						if (match_key[user.User.id] == undefined) {
							match_key[user.User.id] = 1;
							matched.push(user);
						}
					}
				}
				else {
					valid = false;
					if (match_key[user.User.id] == undefined) return;
					if (Array.isArray(matched)) {
						matched = matched.filter(m=>m.User.id != user.User.id);
					}
				}
			}
			//Remove entry if fullfilled another condition
			else {
				if (user.User == undefined) return;
				if (user.User != undefined &&  match_key[user.User.id] == undefined) return;
				if (Array.isArray(matched)) {
					matched = matched.filter(m=>m.User.id != user.User.id);
				}	
			}

		})
		return valid;
	})

	return matched.length > 0 ? matched : matching;
}
